/**
 * Trigger: tr_debtor_payments_insert
 * Purpose: Update account balances and debtor totals when a debtor payment is inserted
 * Table: debtor_payments
 * Event: AFTER INSERT
 */
export const TR_DEBTOR_PAYMENTS_INSERT = `
CREATE TRIGGER tr_debtor_payments_insert
AFTER INSERT ON debtor_payments FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET debtor_payments_amount = debtor_payments_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.payment_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.payment_date);

  UPDATE account_daily_balances
  SET debtor_payments_amount = debtor_payments_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.payment_date;

  UPDATE debtors
  SET total_amount = total_amount + new.amount
  WHERE _id = new.debtor_id;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.payment_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;
END;
`;
